import { render, staticRenderFns } from "./OrderStatusChart.vue?vue&type=template&id=5d8c1510&scoped=true&"
import script from "./OrderStatusChart.vue?vue&type=script&lang=js&"
export * from "./OrderStatusChart.vue?vue&type=script&lang=js&"
import style0 from "./OrderStatusChart.vue?vue&type=style&index=0&id=5d8c1510&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8c1510",
  null
  
)

export default component.exports